import { ChangeDetectorRef, Component } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { EndasureService } from 'src/app/services/feature/Endasure/endasure.service';

@Component({
  selector: 'app-endasure-csa-downtime',
  templateUrl: './endasure-csa-downtime.component.html',
  styleUrls: ['./endasure-csa-downtime.component.scss'],
  standalone: false
})
export class EndasureCsaDowntimeComponent {
  private readonly destroy$ = new Subject<void>();
  constructor(public endasureService: EndasureService, private readonly cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.endasureService.csaData$.pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data != null) {
        this.csaDowntimeForm.patchValue({
          roadsideCallRate: data.roadsideCallRate || 500.00,
          annualRoadsideCallsToActuators: data.annualRoadsideCallsToActuators || 20,
          roadsideCallRateCsaViolation: data.roadsideCallRateCsaViolation || 2000.00,
          annualOutOfServiceCsaViolations: data.annualOutOfServiceCsaViolations || 2,
          fleetDowntimeRate: data.fleetDowntimeRate || 1200.00,
        });
      }

    })


  }



  csaDowntimeForm = new FormGroup({
    roadsideCallRate: new FormControl(500.00, { validators: Validators.required }),
    annualRoadsideCallsToActuators: new FormControl(20, { validators: Validators.required }),
    roadsideCallRateCsaViolation: new FormControl(2000.00, { validators: Validators.required }),
    annualOutOfServiceCsaViolations: new FormControl(2, { validators: Validators.required }),
    fleetDowntimeRate: new FormControl(1200.00, { validators: Validators.required })
  });
  get form() {
    return this.csaDowntimeForm.controls;
  }


  endaSureNxt() {
    if (this.csaDowntimeForm.valid) {
      this.endasureService.csaData$.next(this.csaDowntimeForm.value);
      this.endasureService.currentComponent$.next('endurasurePro');
    }
    else {
      this.csaDowntimeForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }
  endaSureBack() {
    if (this.csaDowntimeForm.valid) {
      this.endasureService.currentComponent$.next('currentProduct');
    }
    else {
      this.csaDowntimeForm.markAllAsTouched();
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    // Complete the destroy$ subject to unsubscribe all subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
